import 'swiper/css';
import Swiper, {Controller, Keyboard} from 'swiper';
import {DESKTOP_BREAKPOINT} from '@/common/scripts/constants';
import {Lethargy} from 'lethargy';
import {throttle} from 'throttle-debounce';
import {Utils} from '@/common/scripts/utils';

const setIsMobile = () => {
    return Utils.getWindowWidth() >= DESKTOP_BREAKPOINT;
};
let isDesktop = setIsMobile();
const MOUSE_SCROLL_DELTA = 100;

// eslint-disable-next-line max-lines-per-function
export default class CircleSlider {
    constructor(circleWrapper, parentSliderInstance = null) {
        this._parentSlider = parentSliderInstance;
        this._circleWrapper = circleWrapper;
        this._captionSliderWrapper = circleWrapper.querySelector('.j-caption-slider');
        this._captionSlider = null;
        this._parentSlide = null;
        this._isAutoMode = false;
        this._circleSlider = null;
        this.speed = 300;
        this._lethargy = new Lethargy(8, 50);
        this._throttleListener = throttle(300, ({deltaY}) => {
            if (!isDesktop || !this._isAutoMode || !this._circleSlider) {
                return;
            }

            // листаем вниз
            if (deltaY > 0) {
                if (this._isAbleScrollNext) {
                    this._circleSlider.slideNext(this.speed);
                } else {
                    this._unlockParentSliderWheel();
                }
            }
            // листаем вверх
            if (deltaY <= 0) {
                if (this._isAbleScrollPrev) {
                    this._circleSlider.slidePrev(this.speed);
                } else {
                    this._unlockParentSliderWheel();
                }
            }
        }, {debounceMode: true});
        this._wheelListener = (event) => {
            (event.deltaY === MOUSE_SCROLL_DELTA || this._lethargy.check(event)) && this._throttleListener(event);
        };

        this._init();
    }

    get isAutoModeEnabled() {
        if (this._parentSlider) {
            return this._isAutoMode && this._parentSlider.isAutoModeEnabled;
        }

        return this._isAutoMode;
    }

    /* !NB: Если родительского слайдера не существует -- сколлим текущий в цикле */
    get _isAbleScrollNext() {
        return ((this._circleSlider.activeIndex < this._circleSlider.slides.length - 2) && this.isAutoModeEnabled) ||
            !this._parentSlider;
    }

    get _isAbleScrollPrev() {
        return ((this._circleSlider.activeIndex > 1) && this.isAutoModeEnabled) || !this._parentSlider;
    }

    activateAsInnerSlider(activeParentSlide) {
        if (!isDesktop && !Utils.isDescendant(this._circleWrapper, activeParentSlide)) {
            return;
        }

        this._parentSlide = activeParentSlide;
        this._isAutoMode = true;

        this._parentSlide?.addEventListener('wheel', this._wheelListener);
    }

    removeAutoMode() {
        if (!isDesktop) {
            return;
        }

        this._isAutoMode = false;

        if (this._parentSlider) {
            this._parentSlider.disableAutoMode();
        }

        this._unlockParentSliderWheel();
        this._parentSlide?.classList.add('is-touched');
    }

    goNextSlide(speedFromParent = null) {
        const speed = speedFromParent || this.speed;

        if (!this._parentSlider) {
            this._circleSlider.slideNext(speed);
        }

        if (this._isAbleScrollNext) {
            this._circleSlider.slideNext(speed);
        } else {
            this._unlockParentSliderWheel();
            this._parentSlider.goNextSlide(speed);
        }
    }

    goPrevSlide(speedFromParent = null) {
        const speed = speedFromParent || this.speed;

        if (this._isAbleScrollPrev) {
            this._circleSlider.slidePrev(speed);
        } else {
            this._unlockParentSliderWheel();
            this._parentSlider.goPrevSlide(speed);
        }
    }

    _init() {
        this._initSwiper();
    }

    _initSwiper() {
        const that = this;

        if (this._captionSliderWrapper) {
            this._captionSlider = new Swiper(this._captionSliderWrapper, {
                modules         : [Controller],
                wrapperClass    : 'j-caption-slider__wrapper',
                slideClass      : 'j-caption-slider__slide',
                slidePrevClass  : 'is-prev',
                slideActiveClass: 'is-active',
                slideNextClass  : 'is-next',
                loop            : true,
                direction       : 'vertical',
                slidesPerView   : 1
            });
        }

        this._circleSlider = new Swiper(this._circleWrapper, {
            modules            : [Controller, Keyboard],
            wrapperClass       : 'j-circle-slider__wrapper',
            slideClass         : 'j-circle-slider__slide',
            slidePrevClass     : 'is-prev',
            slideActiveClass   : 'is-active',
            slideNextClass     : 'is-next',
            slidesPerView      : 1,
            slideToClickedSlide: true,
            loop               : true,
            loopedSlides       : 1,
            keyboard           : {
                enabled       : true,
                onlyInViewport: false
            },
            on: {
                slideNextTransitionStart(swiper) {
                    if (swiper.isEnd && isDesktop) {
                        swiper.slideToLoop(0);
                    }
                },
                slidePrevTransitionStart(swiper) {
                    if (swiper.isBeginning && isDesktop) {
                        swiper.slideToLoop(swiper.realIndex);
                    }
                },
                resize() {
                    isDesktop = setIsMobile();
                },
                click() {
                    that.removeAutoMode();
                },
                touchStart() {
                    that.removeAutoMode();
                }
            }
        });

        if (this._captionSliderWrapper && this._captionSlider) {
            this._captionSlider.controller.control = this._circleSlider;
            this._circleSlider.controller.control = this._captionSlider;
        }
    }

    _unlockParentSliderWheel() {
        if (this._parentSlider?.unpauseScroll) {
            this._parentSlider.unpauseScroll();
        }

        if (this._parentSlider?.disableInnerSliderFlag) {
            this._parentSlider.disableInnerSliderFlag();
        }

        this._parentSlide?.removeEventListener('wheel', this._wheelListener);
    }
}
